export const handleFormatReleaseDate = (releaseDate) => {
  let trimmedReleaseDate = releaseDate.trim();

  if (trimmedReleaseDate.endsWith("–")) {
    return releaseDate.slice(0, -1);
  } else if (trimmedReleaseDate.includes("-")) {
    const [firstYearReleaseDate, lastYearReleaseDate] = trimmedReleaseDate.split("-");

    if (firstYearReleaseDate === lastYearReleaseDate) {
      trimmedReleaseDate = firstYearReleaseDate;
    }

    return trimmedReleaseDate;
  } else {
    return releaseDate;
  }
};